import { type ReactNode, useEffect, useRef } from 'react';

interface ScreenLayoutProps {
  children: ReactNode;
  glowIntensity?: 'default' | 'high';
}

export function ScreenLayout({ children, glowIntensity = 'default' }: ScreenLayoutProps) {
  const ref = useRef(null);

  useEffect(() => {
    (ref.current as HTMLElement | null)?.focus();
  }, []);

  const bgClass = glowIntensity === 'high' ? 'screen-bg screen-bg--reveal' : 'screen-bg';

  return (
    <div
      ref={ref}
      tabIndex={-1}
      className={`min-h-[100dvh] ${bgClass} text-white flex flex-col items-center justify-center px-8 py-6 outline-none overflow-x-hidden overflow-y-auto`}
    >
      <div className="relative z-10 flex flex-col items-center justify-center w-full max-w-[326px]">
        {children}
      </div>
    </div>
  );
}
